import React, { useEffect, useState } from 'react';

const TabMenu = ({ type, title, menuData, mainMenu, subMenu, current, clickMenu, onClickRoute }) => {
    const [hoverIndex, setHoverIndex] = useState(null);

    useEffect(() => {
        if (type !== 'menu' && subMenu && subMenu.length > 0) {
            const filtered = subMenu.filter(item => !type || item.type === type);
            const exists = filtered.some(item => item.id === current);
            if (!exists && filtered.length > 0) {
                clickMenu(filtered[0].id);
            }
        }
    }, [subMenu, current, type, clickMenu]);

    const renderMenu = () => {
        const menuList = type === 'board' ? mainMenu : subMenu;
        const filtered = menuList.filter(item => !type || item.type === type);
        return filtered.map(item => {
            const isSelected = current === item.id;
            const baseClass = type === 'board' ? 'board-tab-menu' : '';
            const className = `${baseClass} ${isSelected ? 'selected' : ''}`.trim();
            return (
                <li key={item.id} className={className} onClick={() => clickMenu(item.id)}>
                    <a>{item.title}</a>
                </li>
            );
        });
    };

    if (type === 'board') {
        return (
            <div className='bg-board'>
                <div className="bg-board-cnts">
                    <p className="board-title">{title}</p>
                    <ul className="board-tab-menu">{renderMenu()}</ul>
                </div>
            </div>
        );
    } else {
        return <ul className="tab-menu">{renderMenu()}</ul>;
    }
};

export default TabMenu;